// extracted by mini-css-extract-plugin
export default {"title":"DataRights_title__5qyTI","choice":"DataRights_choice__-EwWi","description":"DataRights_description__XgM1F","choices":"DataRights_choices__g36Ld"};